<template>
    <div class="main_container">
        <div class="layout_split">

            <RightWing :index="2" :score="currentGame.score" />
            <div style="width:100%; height:100vh;" :class="bgColor">
                <div style="opacity:0; font-size:10px;">space</div>

                <div class="title_container">
                    <div class="section_title_detail_view">{{sectionTitle}}</div>
                    <div class="article_title_container">
                        <div class="article_title_detail_view">"{{articleTitle}}"</div>
                        <div>
                            <span class="clue_media">{{clueMedia}}</span>
                            <span class="clue_title">{{clueTitle}}</span>
                        </div>
                    </div>
                </div>
                <div class="article_title_mobile">{{articleTitle}}</div>

                <b-overlay :show="showOverlay" rounded="sm">
                    <div class="template_area">
                        
                        <ClueKakaoComp v-if="clueMedia=='카카오톡'"
                            @touchElement="touchElement"
                            :clueContents="clueContents" />
                        <ClueNewsPaperComp v-if="clueMedia=='신문'"
                            @touchElement="touchElement"
                            :clueTitle="clueTitle"
                            :clueContents="clueContents" />
                        <CluePaperComp v-if="clueMedia=='논문'"
                            @touchElement="touchElement"
                            :clueTitle="clueTitle"
                            :clueContents="clueContents" />
                        <ClueYoutubeComp v-if="clueMedia=='유튜브'"
                            @touchElement="touchElement"
                            :clueTitle="clueTitle"
                            :clueContents="clueContents" />
                        <ClueCafeComp v-if="clueMedia=='카페'"
                            @touchElement="touchElement"
                            :clueTitle="clueTitle"
                            :clueContents="clueContents" />
                        <ClueKinComp v-if="clueMedia=='지식인'"
                            @touchElement="touchElement"
                            :clueTitle="clueTitle"
                            :clueContents="clueContents" />
                        <ClueInstaComp v-if="clueMedia=='인스타그램'"
                            @touchElement="touchElement"
                            :clueTitle="clueTitle"
                            :clueContents="clueContents" />
                        <ClueFacebookComp v-if="clueMedia=='페이스북'"
                            @touchElement="touchElement"
                            :clueTitle="clueTitle"
                            :clueContents="clueContents" />
                        <ClueBroadcastComp v-if="clueMedia=='방송뉴스'"
                            @touchElement="touchElement"
                            :clueTitle="clueTitle"
                            :clueContents="clueContents" />
                        <ClueBlogComp v-if="clueMedia=='블로그'"
                            @touchElement="touchElement"
                            :clueTitle="clueTitle"
                            :clueContents="clueContents" />

                        <ClueCheckSlotComp
                            class="clue_check_slot"
                            @chooseClue="chooseClue"
                            :clueItemsGameData="gameData"
                            :currentCluePlayerData="currentClue"
                            :checkSlotTrue="checkSlot"
                            :checkSlotFalse="checkSlotFalse" />
                    </div>
                </b-overlay>

                <div v-if="showChooseButton" class="btn_choose_clue" @click="chooseClue">근거 채택하기</div>
                <div v-else class="btn_choose_clue_disable" >근거 채택하기</div>

                
                <div class="category_modal_container" v-if="modalVisible">
                    <div class="category_modal">
                        <div class="x_button_select_modal" @click="modalVisible=false">ⓧ</div>

                        <!-- <div style="text-align:center; font-size:26px; margin-bottom:10px;">선택한 내용에 해당하는 구분을 고르세요.</div> -->
                        <div class="select_modal_contents_area">
                            {{selectedPart.key}}
                        </div>

                        <div style="font-size:18px; text-align:center; margin-top:20px;">근거에 해당하는 항목을 선택해 주세요.</div>
                        <div class="modal_flex_container">
                            <div v-for="item in itemCategoryButtonGroup" :key="item.index"
                                    :class="item.class" @click="touchItemCategory(item.index)">
                                {{item.title}}
                            </div>
                        </div>
                        <div style="font-size:18px; text-align:center; margin-top:20px;">해당 항목은 신뢰할 수 있을까요?</div>
                        <div class="modal_flex_container">
                            <div v-for="item in itemTrueFalseButtonGroup" :key="item.index"
                                    :class="item.class" @click="touchItemTrueFalse(item.index)">
                                {{item.title}}
                            </div>
                        </div>
                        <div class="modal_btn_container">
                            <div class="btn_modal_cancel" @click="modalVisible=false">취소</div>
                            <div class="btn_modal_ok" @click="confirm">확인</div>
                        </div>

                    </div>
                </div>

                <div class="category_modal_container" v-if="resultModalVisible">
                    <div class="category_modal">
                        <div class="x_button_result_modal">ⓧ</div>

                        <div class="result_modal_contents_area">
                            {{selectedPart.key}}
                        </div>

                        <div v-if="isCategoryCorrect" style="background-color:#C5FFCB;" class="modal_message">{{selectedPart.desc}}</div>
                        <div v-else class="modal_message" style="background-color:#FFA8A8;">다시 생각해 보세요.</div>

                        <div v-if="isCategoryCorrect && isTrueFalseCorrect" style="background-color:#C5FFCB;" class="modal_message2">맞았습니다, 잘 하셨어요!</div>
                        <div v-if="isCategoryCorrect && !isTrueFalseCorrect" style="background-color:#FFA8A8;" class="modal_message2">다시 생각해 보세요.</div>
                        <div v-if="!isCategoryCorrect" style="background-color:#C4C4C4;" class="modal_message2"></div>

                        <div v-if="isCategoryCorrect && isTrueFalseCorrect" class="point_message">100점을 얻었습니다!</div>
                        <div v-else class="point_message_dummy" style="opacity:0;">이건 보이지 않는다</div>

                        <div class="btn_result_modal_ok" @click="okResultModal()">확인</div>
                    </div>
                </div>

                <ChooseClueModal v-if="chooseClueModalVisible"
                    @close_choose_clue_modal="chooseClueModalVisible=false" />

                <ChooseClueOkModal v-if="chooseClueOkModalVisible"
                    @close_choose_clue_ok_modal="chooseClueOk" />

            </div>
        </div>
    </div>
</template>

<script>
import ClueKakaoComp from '../components/ClueKakaoComp.vue'
import ClueNewsPaperComp from '../components/ClueNewsPaperComp.vue'
import CluePaperComp from '../components/CluePaperComp.vue'
import ClueYoutubeComp from '../components/ClueYoutubeComp.vue'
import ClueCafeComp from '../components/ClueCafeComp.vue'
import ClueKinComp from '../components/ClueKinComp.vue'
import ClueInstaComp from '../components/ClueInstaComp.vue'
import ClueFacebookComp from '../components/ClueFacebookComp.vue'
import ClueBroadcastComp from '../components/ClueBroadcastComp.vue'
import ClueBlogComp from '../components/ClueBlogComp.vue'

import RightWing from '../components/RightWingView.vue'
import ClueCheckSlotComp from '../components/ClueCheckSlotComp.vue'
import ChooseClueModal from '../components/ChooseClueModal.vue'
import ChooseClueOkModal from '../components/ChooseClueOkModal.vue'

export default {
    name: 'ClueDetailView3',

    components: {
        'ClueKakaoComp': ClueKakaoComp,
        'ClueNewsPaperComp': ClueNewsPaperComp,
        'CluePaperComp': CluePaperComp,
        'ClueYoutubeComp': ClueYoutubeComp,
        'ClueCafeComp': ClueCafeComp,
        'ClueKinComp': ClueKinComp,
        'ClueInstaComp': ClueInstaComp,
        'ClueFacebookComp': ClueFacebookComp,
        'ClueBroadcastComp': ClueBroadcastComp,
        'ClueBlogComp': ClueBlogComp,

        'RightWing': RightWing,
        'ClueCheckSlotComp': ClueCheckSlotComp,
        'ChooseClueModal': ChooseClueModal,
        'ChooseClueOkModal': ChooseClueOkModal,
    },

    data() {
        return {
            gameData: null,
            clueContents: null,

            checkSlot: [],
            checkSlotFalse: [],
            showOverlay: false,
            btnFactcheck: true,
            score: 0,
            modalVisible: false,
            resultModalVisible: false,
            chooseClueModalVisible: false,
            chooseClueOkModalVisible: false,
            selectedPart: null,

            selectedArticleData: null,
            articleTitle: null,
            sectionTitle: null,
            selectedClueData: null,
            clueTitle: null,
            clueMedia: null,
            selectedSectionIndex: null,
            selectedArticleIndex: null,

            itemCategoryButtonGroup: [
                {'index': 0, 'title': '글쓴이', 'class': 'category_item'},
                {'index': 1, 'title': '출처', 'class': 'category_item'},
                {'index': 2, 'title': '작성일', 'class': 'category_item'},
                {'index': 3, 'title': '설명/논리', 'class': 'category_item'},
            ],
            selectedItemCategory: null,
            isCategoryCorrect: false,

            itemTrueFalseButtonGroup: [
                {'index': 0, 'title': '네', 'class': 'category_item'},
                {'index': 1, 'title': '아니오', 'class': 'category_item'},
            ],
            selectedItemTrueFalse: null,
            isTrueFalseCorrect: false,

            currentGame: null,
            currentArticle: null,
            currentClue: null,

            bgColor: 'bg_default'
        }
    },

    created() {
        console.log('ClueDetailView#Created() =====')
        this.currentGame = this.$getCurrentGame()
        const clueIndex = this.currentGame.selectedClue
        this.selectedSectionIndex = this.currentGame.selectedSection
        this.selectedArticleIndex = this.currentGame.selectedArticle

        this.sectionTitle = this.$gameData.sections[this.selectedSectionIndex].title

        this.selectedArticleData = this.$gameData.sections[this.selectedSectionIndex].articles[this.selectedArticleIndex]
        this.articleTitle = this.selectedArticleData.title

        this.selectedClueData = this.selectedArticleData.clues[clueIndex]
        this.clueTitle = this.selectedClueData.title
        this.clueMedia = this.selectedClueData.media
        // console.log(this.clueMedia + '/' + this.clueTitle)
        
        this.clueContents = this.$gameData.sections[this.currentGame.selectedSection].articles[this.selectedArticleIndex].clues[clueIndex].contents
        this.gameData = this.$gameData.sections[this.currentGame.selectedSection].articles[this.selectedArticleIndex].clues[clueIndex].items

        // 선택된 clue를 추가 한다. title을 key로...
        this.currentArticle = null
        for(let article of this.currentGame.articles) {
            if(article.title == this.articleTitle) {
                this.currentArticle = article
            }
        }
        // TODO currentArticle = null 으로 들어오는 이상한 케이스 대응
        // console.log('currentArticle play::')
        // console.log(this.currentArticle)
        // 이미 근거 있는지 검사
        let clueIndexFound = -1
        for(let i = 0; i < this.currentArticle.clues.length; i++) {
            if(this.currentArticle.clues[i].title == this.clueTitle) {
                clueIndexFound = i
                break
            }
        }
        // console.log('clueIndexFound::' + clueIndexFound)
        // 이 근거를 한 번도 선택하지 않았다면 추가
        if(clueIndexFound == -1) {
            this.currentArticle.clues.push({'title': this.clueTitle, 'items': []})
            this.currentClue = this.currentArticle.clues[this.currentArticle.clues.length - 1]
            this.$setCurrentGame(this.currentGame)
        }
        // 이미 근거를 선택한 적이 있다면 로딩 후 입력한 답은 입력되어 있어야 한다
        else {
            this.currentClue = this.currentArticle.clues[clueIndexFound]
        }
        // console.log('currentClue play::')
        // console.log(this.currentClue.title)
        // console.log(this.currentClue)

        this.setBgColor()
    },

    mounted() {
        const highlights = document.getElementsByClassName('highlight')
        this.currentClue.highlightsCount = highlights.length
        this.$setCurrentGame(this.currentGame)

        // console.log(this.currentArticle.cluesChosen)
        for(let chosenClue of this.currentArticle.cluesChosen) {
            if(chosenClue.title == this.clueTitle) {
                this.$router.push('/clueList3')
                break
            }
        }
    },

    computed: {
        showChooseButton: function() {
            // 모든 item이 적합하다면 근거 선택 버튼이 활성화
            if(this.currentClue.highlightsCount == this.checkSlot.length + this.checkSlotFalse.length) {
                return true
            }
            return false;
        }
    },

    methods: {
        touchElement: function(eventTarget) {
            // console.log(eventTarget.style.backgroundColor)
            // console.log(typeof eventTarget.style.backgroundColor)
            // 이미 입력된 것을 터치할 수 없도록 막음
            if(eventTarget.style.backgroundColor != '') {
                console.log('already found')
                return
            }
            // d5d5d5
            // 'rgb(223, 93, 91)'
            // rgb(213, 213, 213)


            // console.log(eventTarget)
            if(eventTarget.nodeName == 'IMG') {
                // console.log(this.gameData)
                let src = eventTarget.attributes.src.value.replace(this.$imgPath, '')
                // console.log(src)
                // console.log(this.gameData[src])
                this.gameData[src].dom = eventTarget
                this.selectedPart = eventTarget
            }
            else {
                this.gameData[eventTarget.innerHTML].dom = eventTarget
                this.selectedPart = this.gameData[eventTarget.innerHTML]
            }

            this.initItemCategoryModal()
            this.initItemTrueFalseModal()
            this.modalVisible = true
        },

        // 근거채택
        chooseClue: function() {
            const clueIndex = this.currentGame.selectedClue
            const curClue = this.$gameData.sections[this.selectedSectionIndex].articles[this.selectedArticleIndex].clues[clueIndex]

            if(curClue.result == '부적합') {
                this.chooseClueModalVisible = true
                return
            }
            
            this.chooseClueOkModalVisible = true
        },

        // 근거 채택 팝업 OK버튼 누름
        chooseClueOk: function() {
            const clueIndex = this.currentGame.selectedClue

            let clueSlot = this.currentArticle.cluesChosen
            if(clueSlot.length < 3) {
                this.currentGame.score = this.currentGame.score + 300

                // clueSlot[selectedClueSlot] = this.$gameData.sections[this.selectedSectionIndex].articles[this.selectedArticleIndex].clues[clueIndex]
                clueSlot.push(this.$gameData.sections[this.selectedSectionIndex].articles[this.selectedArticleIndex].clues[clueIndex])
                // clueSlot[selectedClueSlot].idx = Number(selectedClueSlot)
                this.$setCurrentGame(this.currentGame)
            }
            else {
                // TODO 이미 다 선택했는데요?
                console.log('이미 다 선택했는데요????')
            }

            this.$router.push('/clueList3')
        },

        // 근거 타입과 믿을 수 있는지 여부를 선택하는 모달의 확인 버튼
        confirm: function() {
            // 분류 혹은 믿을 수 있는 지 없는지를 선택 하지 않았다면 확인 버튼이 눌리지 않는다
            if(this.selectedItemCategory == null || this.selectedItemTrueFalse == null) {
                return
            }

            // console.log(this.selectedPart.type)
            // console.log(this.selectedPart.result)

            this.isCategoryCorrect = false
            // 선택한 문장의 분류와 선택한 분류가 같은지 확인
            if((this.selectedPart.type == '저자' && this.selectedItemCategory == 0) ||
                    (this.selectedPart.type == '출처' && this.selectedItemCategory == 1) ||
                    (this.selectedPart.type == '시의성' && this.selectedItemCategory == 2) ||
                    (this.selectedPart.type == '논리' && this.selectedItemCategory == 3)) {
                this.isCategoryCorrect = true
            }

            this.isTrueFalseCorrect = false
            // 선택한 문장이 믿을 수 있는지 없는지(0 = 신뢰, 1 = 믿을 수 없다)
            if((this.selectedPart.result == 'TRUE' && this.selectedItemTrueFalse == 0) ||
                    (this.selectedPart.result == 'FALSE' && this.selectedItemTrueFalse == 1)) {
                this.isTrueFalseCorrect = true
            }

            // 맞은 item을 items에 저장하고 시도 회수를 늘려서 저장한다
            if(this.isTrueFalseCorrect && this.isCategoryCorrect) {
                this.currentClue.items.push(this.selectedPart.key)
            }
            // 전체 시도회수 늘리기
            this.currentGame.num_of_factcheck = this.currentGame.num_of_factcheck + 1
            if(this.selectedPart.type == '출처') {
                this.currentGame.ref_try = this.currentGame.ref_try + 1
                if(this.isTrueFalseCorrect && this.isCategoryCorrect) {
                    this.currentGame.ref_correct = this.currentGame.ref_correct + 1
                }
            }
            else if(this.selectedPart.type == '저자') {
                this.currentGame.author_try = this.currentGame.author_try + 1
                if(this.isTrueFalseCorrect && this.isCategoryCorrect) {
                    this.currentGame.author_correct = this.currentGame.author_correct + 1
                }
            }
            else if(this.selectedPart.type == '시의성') {
                this.currentGame.time_try = this.currentGame.time_try + 1
                if(this.isTrueFalseCorrect && this.isCategoryCorrect) {
                    this.currentGame.time_correct = this.currentGame.time_correct + 1
                }
            }
            else if(this.selectedPart.type == '논리') {
                this.currentGame.logic_try = this.currentGame.logic_try + 1
                if(this.isTrueFalseCorrect && this.isCategoryCorrect) {
                    this.currentGame.logic_correct = this.currentGame.logic_correct + 1
                }
            }
            this.$setCurrentGame(this.currentGame)

            // 현재 선택 모달은 닫고
            this.modalVisible = false
            // 맞았는지 틀렸는지 결과 모달 노출
            this.resultModalVisible = true

            if(this.isTrueFalseCorrect && this.isCategoryCorrect) {
                this.$playSuccess()
            }
            else {
                this.$playBeep()
            }
        },

        initItemCategoryModal: function() {
            for(let item of this.itemCategoryButtonGroup) {
                item.class = 'category_item'
            }
            this.selectedItemCategory = null
        },

        initItemTrueFalseModal: function() {
            for(let item of this.itemTrueFalseButtonGroup) {
                item.class = 'category_item'
            }
            this.selectedItemTrueFalse = null
        },

        // 어느 카테고리에 해당하는지 누름(저자, 출처, 시의성, 논리)
        touchItemCategory: function(index) {
            for(let item of this.itemCategoryButtonGroup) {
                item.class = 'category_item'
            }
            this.itemCategoryButtonGroup[index].class = 'category_item_selected'
            this.selectedItemCategory = index
        },

        // 믿을 수 있는 내용인지 아닌지 누름
        touchItemTrueFalse: function(index) {
            for(let item of this.itemTrueFalseButtonGroup) {
                item.class = 'category_item'
            }
            this.itemTrueFalseButtonGroup[index].class = 'category_item_selected'
            this.selectedItemTrueFalse = index
        },

        okResultModal: function() {
            // 맞았으면 해당 내용을 각각의 슬롯에 넣음
            if(this.isCategoryCorrect && this.isTrueFalseCorrect) {
                if(this.selectedPart.result == 'TRUE') {
                    this.selectedPart.dom.style.backgroundColor = '#64ACF8'
                    this.checkSlot.push(this.selectedPart)
                }
                else {
                    this.selectedPart.dom.style.backgroundColor = '#DF5D5B'
                    this.checkSlotFalse.push(this.selectedPart)
                }

                // 전부 확인했는지 보고 전부 확인했다면 체크 버튼 노출하는 기능은
                // ClueCheckSlotComp에 computed로 구현

                this.currentGame.score = this.currentGame.score + 100
                this.$setCurrentGame(this.currentGame)
            }

            this.resultModalVisible = false
        },

        setBgColor: function() {
            if(this.clueMedia == '페이스북') {
                this.bgColor = 'bg_facebook'
            }
            else if(this.clueMedia == '카카오톡') {
                this.bgColor = 'bg_kakao'
            }
            else if(this.clueMedia == '논문') {
                this.bgColor = 'bg_paper'
            }
            else if(this.clueMedia == '신문') {
                this.bgColor = 'bg_default'
            }
            else if(this.clueMedia == '블로그') {
                this.bgColor = 'bg_naver'
            }
            else if(this.clueMedia == '유튜브') {
                this.bgColor = 'bg_youtube'
            }
            else if(this.clueMedia == '지식인') {
                this.bgColor = 'bg_naver'
            }
            else if(this.clueMedia == '카페') {
                this.bgColor = 'bg_naver'
            }
            else if(this.clueMedia == '인스타그램') {
                this.bgColor = 'bg_instagram'
            }
            else if(this.clueMedia == '방송뉴스') {
                this.bgColor = 'bg_default'
            }

        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@keyframes scale_animation {
    from {
        transform: scale(1.5);
        opacity: 0;
    }
    to {
        transform: scale(1.0);
        opacity: 1;
    }
}
.bg_facebook {
    background-color: #1877F2;
}
.bg_kakao {
    background-color: #FFE600;
}
.bg_instagram {
    background-color: #FF71D7;
}
.bg_naver {
    background-color: #00C73C;
}
.bg_default {
    background-color: #C4C4C4;
}
.bg_youtube {
    background-color: #FF5151;
}
.bg_paper {
    background-color: #FFFCEB;
}
.category_modal_container {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: #000000cc;
    top: 0px;
    left: 0px;
    z-index: 5;
}




/* pc */
@media screen and (min-width: 415px) {
    .category_modal {
        position: fixed;
        width: 670px;
        height: 540px;
        background-color: white;
        top: 50px;
        left: calc(50vw - (670px / 2));
        border-radius: 5px;
        z-index: 10;
    }
    .btn_modal_ok {
        border:2px solid black;
        margin: 15px auto;
        padding: 10px;
        width: 300px;
        font-size:26px;
        text-align:center;
        box-shadow:3px 3px 3px grey;
        cursor:pointer;
    }
    .btn_result_modal_ok {
        border:2px solid black;
        margin: 15px auto;
        padding: 10px;
        width: 300px;
        font-size:26px;
        text-align:center;
        box-shadow:3px 3px 3px grey;
        cursor:pointer;
    }
    .modal_message {
        font-size: 22px;
        background-color: gray;
        text-align: center;
        margin: 20px;
        height: 80px;
        padding: 10px;
        overflow: hidden;
    }
    .modal_message2 {
        font-size: 22px;
        background-color: gray;
        text-align: center;
        margin: 20px;
        height: 80px;
        padding: 10px;
        overflow: hidden;
    }
    .point_message {
        font-size: 22px;
        font-weight: 700;
        text-align: center;
        margin: 20px;
        padding: 10px;
        color: red;
        animation-name: scale_animation;
        animation-duration: 0.3s;
        animation-iteration-count: 1;
    }

    .section_title_detail_view {
        padding-top: 13px;
        text-align: center;
        color: white;
        font-size: 30px;
        font-weight: 700;

        width: 200px;
        height: 70px;

        background-repeat: no-repeat;
        background-image:url("../assets/img/black_bg.png");
        background-size: 200px;
        z-index: 2;
    }
    .article_title_container {
        margin-left: -30px;    
        padding-left: 55px;
        padding-right: 25px;
        padding-top: 7px;
        padding-bottom: 7px;

        border: gray solid 1px;
        background-color:white;
        z-index: 1;
    }
    .article_title_detail_view {
        font-size:20px;
        font-weight:700;
    }
    .clue_media {
        font-size: 26px;
        font-weight:700;
        margin-right: 15px;
    }
    .clue_title {
        font-size: 26px;
    }
    .layout_split {
        display:flex;
    }
    .main_area {
        width: 100%;
        background-color:#e5e5e5
    }
    .title_container {
        display:flex;
        margin-left:20px;
        align-items:center;
    }
    .article_title_mobile {
        display: none;
    }
    .btn_choose_clue {
        display: none;
    }
    .btn_choose_clue_disable {
        display: none;
    }
    .template_area {
        display:flex;
        flex-wrap:nowrap;
        margin:10px;
    }
    .x_button_select_modal {
        height:30px;
        font-size:26px;
        padding:0px 3px;
        font-weight:700;
        text-align:right;
        cursor:pointer;
    }
    .x_button_result_modal {
        height:30px;
        font-size:26px;
        padding:0px 3px;
        font-weight:700;
        text-align:right;
        opacity:0;
        cursor:pointer;
    }
    .category_item {
        font-size: 20px;
        margin: 5px 10px;
        padding: 15px 10px;
        border: 1px solid black;
        text-align: center;
        color: black;
        /* flex-grow: 1; */
        width: 350px;
        background-color: white;
        box-shadow:3px 3px 3px grey;
        cursor:pointer;
    }
    .category_item_selected {
        font-size: 20px;
        margin: 5px 10px;
        padding: 15px 10px;
        border: 1px solid black;
        text-align: center;
        color: white;
        /* flex-grow: 1; */
        width: 350px;
        background-color: gray;
    }
    .modal_flex_container {
        padding: 5px;
        display: flex;
        justify-content: space-between;
        margin: 10px 20px;
        background-color: #F2F2F2;
    }
    .select_modal_contents_area {
        margin:10px 20px;
        overflow:auto;
        height:110px;
        padding:10px;
        font-size:20px;
        background-color:#F2F2F2;
        color:black;
    }
    .result_modal_contents_area {
        margin: 10px 20px;
        overflow:auto;
        height:120px;
        padding:10px;
        font-size:20px;
        background-color:#F2F2F2;
        color:black;
    }
    .btn_modal_cancel {
        display: none;
    }
    .modal_btn_container {
        display: flex;
        display: flex;
        font-size: 22px;
        text-align: center;
        margin-top: 14px;
    }

}

/* mobile */
@media screen and (max-width: 414px) {
    .layout_split {
        display:flex;
        flex-direction:column;
    }
    .main_area {
        width:100%;
        background-color:#e5e5e5
    }
    .clue_check_slot {
        display: none;
    }
    .title_container {
        display: none;
    }
    .article_title_mobile {
        text-align: center;
        color: black;
        font-size: 22px;
        font-weight: 700;
        /* border-bottom: solid black 1px; */
        text-decoration: underline;
    }

    .btn_choose_clue {
        text-align: center;
        padding: 10px;
        margin: 0px 15px;
        border: 2px solid black;
        box-shadow:3px 3px 3px grey;
        font-weight: 700;
        font-size: 20px;
        color: white;
        cursor:pointer;
        background-color: black;
    }
    .btn_choose_clue_disable {
        text-align: center;
        padding: 10px;
        margin: 0px 15px;
        border: 1px solid gray;
        font-weight: 700;
        font-size: 20px;
        color: white;
        background-color: lightgray;
    }
    .category_modal {
        position: fixed;
        width: 350px;
        height: 400px;
        background-color: white;
        /* top: 50px; */
        top: calc(50vh - (400px / 2) - 30px);
        left: calc(50vw - (350px / 2));
        z-index: 10;
    }
    .x_button_select_modal {
        display: none;
    }
    .x_button_result_modal {
        display: none;
    }
    .category_item {
        font-size: 12px;
        margin: 5px 5px;
        padding: 10px 0px;
        border: 1px solid black;
        text-align: center;
        color: black;
        /* flex-grow: 1; */
        width: 250px;
        background-color: white;
        box-shadow: 2px 2px 2px grey;
    }
    .category_item_selected {
        font-size: 12px;
        margin: 5px 5px;
        padding: 10px 0px;
        border: 1px solid black;
        text-align: center;
        color: white;
        /* flex-grow: 1; */
        width: 250px;
        background-color: gray;
    }
    .modal_flex_container {
        display: flex;
        justify-content: space-between;
        margin: 10px 0px;
    }
    .select_modal_contents_area {
        margin:10px 20px;
        overflow:auto;
        height:110px;
        padding:10px;
        font-size:16px;
        background-color:#F2F2F2;
        color:black;
    }
    .result_modal_contents_area {
        margin:10px 20px;
        overflow:auto;
        height:110px;
        padding:10px;
        font-size:16px;
        background-color:#F2F2F2;
        color:black;
    }
    .btn_modal_ok {
        /* border-top: 1px solid black; */
        /* margin-top: 25px; */
        /* padding: 5px; */
        /* font-size: 20px; */
        /* text-align:center; */
        padding: 10px;
        flex-grow: 1;
        background-color: white;
    }
    .btn_modal_cancel {
        /* border-top: 1px solid black; */
        /* margin-top: 25px; */
        /* padding: 5px; */
        /* font-size: 20px; */
        /* text-align:center; */
        padding: 10px;
        flex-grow: 1;
        background-color: gray;
    }
    .modal_message {
        font-size: 16px;
        background-color: gray;
        text-align: center;
        margin: 10px 20px;
        height: 85px;
        padding: 10px;
        overflow: hidden;
        word-break: keep-all;
    }
    .modal_message2 {
        font-size: 16px;
        background-color: gray;
        text-align: center;
        margin: 10px 20px;
        height: 50px;
        padding: 10px;
        overflow: hidden;
        word-break: keep-all;
    }
    .point_message {
        font-size: 18px;
        font-weight: 700;
        text-align: center;
        margin: 5px 20px;
        padding: 5px;
        color: red;
        animation-name: scale_animation;
        animation-duration: 0.3s;
        animation-iteration-count: 1;
    }
    .point_message_dummy {
        font-size: 18px;
        font-weight: 700;
        text-align: center;
        margin: 5px 20px;
        padding: 5px;
    }
    .modal_btn_container {
        display: flex;
        border-top: black solid 1px;
        display: flex;
        font-size: 22px;
        text-align: center;
        margin-top: 14px;
    }
    .btn_result_modal_ok {
        border-top: black solid 1px;
        font-size: 22px;
        margin-top: 19px;
        text-align: center;
        padding: 10px;
    }

}
</style>
